var a=Object.freeze({imageDefaultColor:[255,255,255,1],imageDefaultBackgroundColorRgba:{r:255,g:255,b:255,a:100},imageDefaultBackgroundColorString:"rgba(255, 255, 255, 1)"});export{a as ImageEditorConstants};
//# sourceMappingURL=ImageEditor.constants.js.map
